import { z } from "zod";
import { Id, IsoDateTime, Money } from "./common.ts";

export const MenuCategory = z.enum(["drinks", "cocktails", "beer", "food", "snacks", "other"]);
export type MenuCategory = z.infer<typeof MenuCategory>;

export const MenuItem = z.object({
  id: Id,
  venueId: Id,
  name: z.string().min(1),
  nameTh: z.string().optional(),
  description: z.string().optional(),
  category: MenuCategory,
  price: Money,
  imageUrl: z.url().optional(),
  /** Eligible to be sent as a "Just One Drink" gift to another table. */
  giftable: z.boolean().default(true),
  isAvailable: z.boolean().default(true),
  createdAt: IsoDateTime,
});
export type MenuItem = z.infer<typeof MenuItem>;

export const Menu = z.object({
  venueId: Id,
  categories: z.array(MenuCategory),
  items: z.array(MenuItem),
});
export type Menu = z.infer<typeof Menu>;
